<template>
  <div :class="{root: true, sidebarClose, sidebarStatic}">
    <Sidebar />
    <div class="wrap d-flex flex-column vh-100">
      <Header />
      <v-touch class="content w-100" @swipe="handleSwipe" :swipe-options="{direction: 'horizontal'}">
        <router-view />
      </v-touch>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import Sidebar from "@/components/Sidebar/Sidebar";
import Header from "@/components/Header/Header";

import "./Layout.scss";

export default {
  name: "Layout",
  components: { Sidebar, Header },
  methods: {
    ...mapActions("layout", [
      "switchSidebar",
      "handleSwipe",
      "changeSidebarActive"
    ])
  },
  computed: {
    ...mapState("layout", {
      sidebarClose: state => state.sidebarClose,
      sidebarStatic: state => state.sidebarStatic
    })
  }
};
</script>

<style src="./Layout.scss" lang="scss" />
